/* Cart drawer + AJAX add-to-cart.
   One fetch per mutation, one render. No framework, no state library. */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var R        = window.DRMEDYX.routes;
  var panel    = drawer.querySelector('.drawer__panel');
  var body     = drawer.querySelector('[data-cart-body]');
  var foot     = drawer.querySelector('[data-cart-foot]');
  var empty    = drawer.querySelector('[data-cart-empty]');
  var shipEl   = drawer.querySelector('[data-cart-ship]');
  var subtotal = drawer.querySelector('[data-cart-subtotal]');
  var countEl  = document.querySelector('[data-cart-count]');
  var threshold = Number(drawer.dataset.freeThreshold);
  var lastFocus = null;

  var inr = new Intl.NumberFormat('en-IN', {
    style: 'currency', currency: 'INR', maximumFractionDigits: 0
  });
  function money(p) { return inr.format(p / 100); }

  /* ── open / close ─────────────────────────────────────────────── */

  function open() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      panel.querySelector('button, a').focus();
    });
  }
  function close() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 160);
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); }
    if (e.target.closest('[data-cart-open]'))  { e.preventDefault(); refresh().then(open); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
    if (e.key === 'Tab' && !drawer.hidden) trap(e);
  });

  function trap(e) {
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ── render ───────────────────────────────────────────────────── */

  function render(cart) {
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.hidden = cart.item_count === 0;
    }

    var isEmpty = cart.item_count === 0;
    empty.hidden = !isEmpty;
    foot.hidden  = isEmpty;
    shipEl.hidden = isEmpty;

    body.innerHTML = cart.items.map(function (i) {
      return '<article class="citem">' +
        (i.image
          ? '<img class="citem__img" src="' + i.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') +
            '" alt="" width="72" height="72" loading="lazy">'
          : '<span class="citem__img citem__img--empty"></span>') +
        '<div class="citem__main">' +
          '<p class="citem__title">' + i.product_title + '</p>' +
          (i.variant_title ? '<p class="citem__variant label">' + i.variant_title + '</p>' : '') +
          '<div class="citem__row">' +
            '<div class="qty">' +
              '<button type="button" class="qty__btn" data-line="' + i.key + '" data-delta="-1" aria-label="−">−</button>' +
              '<span class="qty__n data">' + i.quantity + '</span>' +
              '<button type="button" class="qty__btn" data-line="' + i.key + '" data-delta="1" aria-label="+">+</button>' +
            '</div>' +
            '<span class="citem__price data">' + money(i.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');

    subtotal.textContent = money(cart.total_price);

    var gap = threshold - cart.total_price;
    shipEl.textContent = gap > 0
      ? shipEl.dataset.msgProgress.replace('{amount}', money(gap))
      : shipEl.dataset.msgFree;
    shipEl.classList.toggle('is-free', gap <= 0);
  }

  function refresh() {
    return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); return c; });
  }

  /* ── mutations ────────────────────────────────────────────────── */

  body.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-delta]');
    if (!btn) return;
    var n = Number(btn.parentNode.querySelector('.qty__n').textContent) + Number(btn.dataset.delta);
    fetch(R.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: btn.dataset.line, quantity: Math.max(0, n) })
    }).then(function (r) { return r.json(); }).then(render);
  });

  var form = document.querySelector('[data-atc-form]');
  if (form) {
    var status = form.querySelector('[data-atc-status]');
    var button = form.querySelector('[data-atc]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (button.disabled) return;
      button.disabled = true;
      status.className = 'pdp__atc-status';
      status.textContent = '';

      fetch(R.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          // State what happened and how to fix it. Never apologise, never be vague.
          status.className = 'pdp__atc-status is-error';
          status.textContent = res.body.description || res.body.message || form.dataset.msgFail;
          return;
        }
        status.className = 'pdp__atc-status is-ok';
        status.textContent = form.dataset.msgAdded;
        return refresh().then(open);
      })
      .finally(function () { button.disabled = false; });
    });
  }

  refresh();
})();
